import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
// import { AuthGuard} from './gaurd/auth.guard'


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./sign-in/sign-in.module').then( m => m.SignInPageModule)
    // ,canActivate:[AuthGuard]
  },
  {
    path: 'tabs',
    // loadChildren: () => import('./tab1/tab1.module').then(m => m.Tab1PageModule)
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'success',
    loadChildren: () => import('./success/success.module').then( m => m.SuccessPageModule)
  },
  {
    path: 'payment-response',
    loadChildren: () => import('./payment-response/payment-response.module').then( m => m.PaymentResponsePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./sign-in/sign-in.module').then( m => m.SignInPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'raise-dispute',
    loadChildren: () => import('./raise-dispute/raise-dispute.module').then( m => m.RaiseDisputePageModule)
  },
  {
    path: 'document-list',
    loadChildren: () => import('./document-list/document-list.module').then( m => m.DocumentListPageModule)
  },  {
    path: 'landing-screen',
    loadChildren: () => import('./landing-screen/landing-screen.module').then( m => m.LandingScreenPageModule)
  },
  {
    path: 'landing-screen',
    loadChildren: () => import('./landing-screen/landing-screen.module').then( m => m.LandingScreenPageModule)
  }


];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
